export const SITE_DATA = 'site_data'
export const ENG_DISTANCE_DATA = 'eng_distance_data'
export const DISTANCE_DETAILS = 'distance_calculate'
export const DISTANCE_DAILY_TASK = 'daily_task'